import { useField } from "@unform/core";
import { forwardRef, useEffect, useRef, useState } from "react";

import * as S from "./styles";

import { useTheme } from "styled-components";

// eslint-disable-next-line react/display-name
const Checkbox = forwardRef(
  ({ label, required, size, name, defaultChecked, onChange, ...rest }, ref) => {
    const theme = useTheme();

    const checkboxRef = useRef(null);
    const { fieldName, defaultValue, registerField } = useField(name);
    const [checked, setChecked] = useState(defaultChecked);

    useEffect(() => {
      setChecked(defaultChecked);
    }, [defaultChecked]);

    useEffect(() => {
      registerField({
        name: fieldName,
        ref: ref ? ref.current : checkboxRef.current,
        path: "checked",
      });
    }, [fieldName, registerField]);

    return (
      <S.Wrapper htmlFor={fieldName} {...rest}>
        <S.HiddenCheckboxStylesStructure
          id={fieldName}
          type="checkbox"
          ref={checkboxRef}
          defaultValue={defaultValue}
          defaultChecked={defaultChecked || defaultValue}
          checked={checked}
          required={required}
          onChange={(e) => {
            onChange && onChange(e);
            setChecked(e.target.checked);
          }}
          size={size}
          {...rest}
        />
        <S.CheckboxDisplayed checked={checked}>
          {/* DONT TRY TO PUT THIS ICON IN GET ICON IT SHOULD NOT CHANGE ITS PROPERTIES */}
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.67959 0.142574C7.25173 -0.110891 6.7383 -0.0264025 6.48158 0.39604L2.88757 5.63432L1.51842 3.86007C1.2617 3.52211 0.662697 3.43762 0.320409 3.69109C-0.021878 3.94455 -0.10745 4.53597 0.149266 4.87393L2.28856 7.66205C2.45971 7.91551 2.71642 8 2.97314 8C3.22985 8 3.48657 7.83102 3.65771 7.66205L7.85073 1.4099C8.10745 0.90297 8.02188 0.39604 7.67959 0.142574Z"
              fill={theme.colors.neutral.white}
            />
          </svg>
        </S.CheckboxDisplayed>
        {label && <S.TextLabel size={size}>{label}</S.TextLabel>}
      </S.Wrapper>
    );
  },
);

export default Checkbox;
